<template lang="pug">
v-container.px-0
	v-row(justify="start")
		v-col.shrink.hidden-xs-only(cols="12" md="auto")
			nuxt-link(:to="localePath({name: 'areas-area', params: {area: slug}})")
				v-img(v-if="skimap && skimap.url" :width="$vuetify.breakpoint.smAndUp ? 120: 'auto'" :aspect-ratio="4/3" :src="`${skimap.url}?width=120`" :alt="skimap.alt")
		v-col.grow
			v-row.mb-1(align="center" no-gutters)
				v-col.mr-1.mb-2.shrink
					img.flag.lg(:src="`https://static.wintersport.nl/images/flags/svg/${country.countryCode}.svg`" :alt="country.name" width="16")
				v-col.mr-1.text-no-wrap.shrink
					nuxt-link( :to="localePath({name: 'areas-area', params: {area: slug}})" :title="`Wintersport ${name}`")
						h2.d-inline-block.font-weight-bold.mb-0.title(style="max-width:100%; overflow:hidden") {{name}}
				v-col.mr-1.mb-2.text-no-wrap.shrink(v-if="reviews && reviews.voteCount")
					span.caption.grey--text {{$tc('areas_list_item.reviews_{average}_{count}', reviews.voteCount, {count: reviews.voteCount, average: Math.round(reviews.average * 10) / 10})}}
			factline(v-if="pistes")
				li(icon="valley-run") {{$tc('areas_list_item.pistes_km_{count}', pistes.total, { count: pistes.total })}}
				li
					.graphbar.inline
						div(:style="{width:`${pistes.total/6.5}%`}")
							.piste-green(:style="{width: `${pistes.green_percentage}%`}")
							.piste-blue(:style="{width: `${pistes.blue_percentage}%`}")
							.piste-red(:style="{width: `${pistes.red_percentage}%`}")
							.piste-black(:style="{width: `${pistes.black_percentage}%`}")
			factline
				li(icon="highway" v-if="departures.city  && departures.city.distance != 9999") {{$t('areas_list_item.{distance}_{city}', { distance: departures.city.distance, city:departures.city.node.name })}}
				li(icon="highway" v-if="departures.highway") {{$t('areas_list_item.{distance}_highway', {distance: departures.highway.distance})}}
				li(icon="peak-height" v-if="departures.highway") {{$t('areas_list_item.elevation{min}{max}', {min: minElevation, max: maxElevation})}}
				li(icon="snowflake" v-if="snowheights.nodes.length && snowheights.nodes[0].snowMountain") {{snowheights.nodes[0].snowMountain}}cm
			slot
</template>

<style lang="sass">
.graphbar
	display: inline-block
	width: 200px
	height: 8px
	line-height: 8px
	padding: 0
	&>div
		height: 10px
	&>div>div
		display: block
		padding: 0
		margin: 0
		height: 8px
		float: left
	@each $name, $color in $piste-colors
		.piste-#{$name}
			background-color: $color !important
</style>

<script>
export default {
	props: [
		'country',
		'features',
		'id',
		'maxElevation',
		'minElevation',
		'name',
		'pistes',
		'resorts',
		'snowheights',
		'slug',
		'departures',
		'reviews',
		'skimap'
	],
	data() {
		return {
			visibleResortFeatures: []
		};
	},
	methods: {
		setCompareDestination(event) {
			event.target.checked
				? window.addDestinationToCompare(
						this.id,
						this.name,
						this.$cdn(this.skimap_id, 'skimaps', 'w=120')
				  )
				: window.removeDestinationFromCompare(this.id);
		},
		resortFeatures(type) {
			return this.resorts.nodes
				.map(resort => {
					const feature = resort.features.find(f => f.type == type);

					if (
						feature &&
						feature.rating > 1 &&
						this.matchingResortIds.includes(resort.id)
					) {
						resort.text = feature.text;
						resort.rating = feature.rating;
						return resort;
					}
					return false;
				})
				.filter(e => e);
		}
	}
};
</script>
